import { useEffect, useState } from "react";
import { Package, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

// Profile summary uses recorded Shared deliveries, without inferring avoided emissions.
export default function CustomerCO2Widget() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/customers/me/co2-stats");
        if (!cancelled) setStats(data);
      } catch (e) {
        if (!cancelled) setError(e.message || "Errore nel caricamento");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="card-soft p-5 sm:p-6 flex items-center gap-2 text-sm text-dapnow-muted" data-testid="customer-co2-widget-loading">
        <Loader2 className="h-4 w-4 animate-spin" /> Caricamento consegne Shared…
      </div>
    );
  }
  if (error || !stats) return null;

  const month = stats.month || {};
  const lifetime = stats.lifetime || {};
  const hasAny = (lifetime.shared_orders || 0) > 0;

  return (
    <section
      className="card-soft p-5 sm:p-6 border-l-4 border-l-emerald-500"
      data-testid="customer-co2-widget"
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100">
          <Package className="h-5 w-5" />
        </span>
        <div>
          <p className="overline text-emerald-700">Storico consegne Shared</p>
          <p className="text-sm text-dapnow-muted">Conteggi delle consegne registrate con categoria Shared.</p>
        </div>
      </div>

      {!hasAny ? (
        <p className="mt-4 text-sm text-dapnow-muted" data-testid="customer-co2-widget-empty">
          Non hai ancora consegne Shared completate.
        </p>
      ) : (
        <div className="mt-4 grid sm:grid-cols-2 gap-3">
          <div className="rounded-2xl bg-emerald-50/70 p-4 ring-1 ring-emerald-100" data-testid="customer-co2-month">
            <p className="overline text-emerald-800 text-[10px]">Questo mese</p>
            <p className="font-display text-2xl font-extrabold tracking-tight mt-1 text-dapnow-ink">
              <span data-testid="customer-co2-month-orders">{month.shared_orders || 0}</span>{" "}
              <span className="text-sm font-semibold text-dapnow-muted">consegne completate</span>
            </p>
          </div>

          <div className="rounded-2xl bg-dapnow-bg p-4" data-testid="customer-co2-lifetime">
            <p className="overline text-[10px]">Da sempre</p>
            <p className="font-display text-2xl font-extrabold tracking-tight mt-1 text-dapnow-ink">
              <span data-testid="customer-co2-lifetime-orders">{lifetime.shared_orders || 0}</span>{" "}
              <span className="text-sm font-semibold text-dapnow-muted">consegne completate</span>
            </p>
          </div>
        </div>
      )}

      <p className="mt-4 text-[11px] leading-relaxed text-dapnow-muted" data-testid="customer-co2-widget-disclaimer">
        Shared è il futuro servizio per driver privati: non è ancora prenotabile. Lo storico resta consultabile.
        {" "}<a href="/become-driver" className="font-semibold underline">Richiedi informazioni</a>.
      </p>
    </section>
  );
}
